import isEqual from 'lodash/isEqual';

export const callbackOnDifference = (() => {
  const cache: Record<string, Record<string, string[] | string>> = {};

  return ({
    callback = () => {},
    data,
    fieldName,
    ruleName,
  }: {
    callback: () => void;
    data: any;
    fieldName: string;
    ruleName: string;
  }) => {
    if (!Object.hasOwn(cache, fieldName)) cache[fieldName] = {};
    if (!Object.hasOwn(cache[fieldName], ruleName))
      cache[fieldName][ruleName] = '';

    const isEqualData = isEqual(data, cache[fieldName][ruleName]);

    if (!isEqualData) {
      cache[fieldName][ruleName] = data;
      callback();
    }
  };
})();
